import script from "./RolMixin.vue?vue&type=script&lang=js"
export * from "./RolMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__